import firebase from "../firebase";

export default function() {
  return firebase.functions().httpsCallable("allFunctions")({
    funcRole: "user",
    funcName: "getOfficeList"
  });
}
